import { Action, OverlayReducer, initialState } from "./reducer"
import React, { Dispatch, ReactNode, useReducer } from "react"

const OverlayStateContext = React.createContext<typeof initialState | undefined>(undefined)
const OverlayDispatchContext = React.createContext<Dispatch<Action> | undefined>(undefined)

const useOverlayState = () => {
    const context = React.useContext(OverlayStateContext)
    if (context === undefined) {
        throw new Error("useOverlayState must be used within a OverlayProvider")
    }

    return context
}

const useOverlayDispatch = () => {
    const context = React.useContext(OverlayDispatchContext)
    if (context === undefined) {
        throw new Error("useOverlayDispatch must be used within a OverlayProvider")
    }

    return context
}

type OverlayProviderProps = {
    children: ReactNode
}

const OverlayProvider = ({ children }: OverlayProviderProps) => {
    const [state, dispatch] = useReducer(OverlayReducer, initialState)

    return (
        <OverlayStateContext.Provider value={state}>
            <OverlayDispatchContext.Provider value={dispatch}>{children}</OverlayDispatchContext.Provider>
        </OverlayStateContext.Provider>
    )
}

export { useOverlayState, useOverlayDispatch, OverlayProvider }
